import { render, staticRenderFns } from "./Aigc.vue?vue&type=template&id=059be406&scoped=true&"
import script from "./Aigc.vue?vue&type=script&lang=js&"
export * from "./Aigc.vue?vue&type=script&lang=js&"
import style0 from "./Aigc.vue?vue&type=style&index=0&id=059be406&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059be406",
  null
  
)

export default component.exports